import {Typography, alpha} from '@mui/material'
import React from 'react'

import {LabelProps} from '../RangeSlider/Label'

interface GetDayRangeSliderLabelParams {
  checkIsWeekend: (value: number) => boolean
  // When true (legacy blue surface) labels are white. When false they use theme
  // text tokens so they stay visible on the light/dark Fundamental surfaces.
  inverted?: boolean
}

export const getDayRangeSliderLabel = ({
  checkIsWeekend,
  inverted = true
}: GetDayRangeSliderLabelParams): React.FC<LabelProps> =>
  React.memo(({formatLabel, value, ...props}) => {
    const labelValue = formatLabel?.(value)
    const isWeekend = checkIsWeekend(value)
    return (
      <Typography
        variant="body1"
        sx={{
          textAlign: 'center',
          pointerEvents: 'none',
          flex: 1,
          color: ({palette}) =>
            inverted
              ? isWeekend
                ? alpha(palette.common.white, 0.6)
                : palette.common.white
              : isWeekend
                ? palette.text.secondary
                : palette.text.primary
        }}
        {...props}
      >
        {labelValue}
      </Typography>
    )
  })
